export default __webpack_public_path__ + "static/media/pop_expression.c4adcb26.png";